import { Id } from '@ess/jg-rule-executor';
import { Retailer } from '@src/app/model/retailer';

export class RetailerScope {
  id: Id<Retailer>;
  name: string;

  constructor(id: Id<Retailer>, name: string) {
    this.id = id;
    this.name = name;
  }
}
